import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import initialState from '../../../../../reducers/initialState';
import { OFFER_FINANCIAL_PRODUCT_INVALIDATED } from 'actions/eventTypes/offer/financials/offerFinancialProduct';
import { OFFER_PARTNER_DELETED } from 'features/offer/edit/client/form/eventTypes';
import { LOAD_PARTNER_FILE_HEADER_SUCCESS } from 'features/partnerFile/actionTypes';

export default function reducer(state = initialState.currentOffer.header, action) {
  switch (action.type) {
    case actionTypes.UPDATE_OFFER_HEADER_STARTED: {
      return {
        ...action.payload.offerHeader,
        savingGeneralData: true
      };
    }

    case actionTypes.UPDATE_OFFER_HEADER_FAILED: {
      return {
        ...state,
        savingGeneralData: false
      };
    }

    case actionTypes.UPDATE_OFFER_HEADER_SUCCESS: {
      return {
        ...action.payload.offerHeader,
        savingGeneralData: false
      };
    }

    case OFFER_PARTNER_DELETED: {
      const key = action.event.eventBody.partnerId;
      const offerPartners = { ...state.client };
      delete offerPartners[key];
      return {
        ...state,
        offerPartners
      };
    }

    case eventTypes.OFFER_HEADER_UPDATED: {
      let { documentId, siteId, client, offerNumber, stateId, stateName, documentTypeId, offerTypeId } = state;
      let newState = {
        ...initialState.currentOffer.header,
        documentId,
        siteId,
        client,
        offerNumber,
        stateId,
        stateName,
        documentTypeId,
        offerTypeId
      };
      return newState;
    }

    case LOAD_PARTNER_FILE_HEADER_SUCCESS: {
      let { documentId, siteId } = action.payload;
      let newState = {
        ...initialState.currentOffer.header,
        documentId,
        siteId
      };
      return newState;
    }

    case eventTypes.OFFER_TYPE_UPDATED: {
      const { documentId, siteId, offerTypeId, offerTypeName } = action.event.eventBody;

      return {
        ...state,
        documentId,
        siteId,
        offerTypeId,
        offerTypeName
      };
    }

    case OFFER_FINANCIAL_PRODUCT_INVALIDATED: {
      return initialState.currentOffer.header;
    }

    default:
      return state;
  }
}
